(function (upp) {
    'use strict';

    upp.config(['$routeProvider',
        function ($routeProvider) {

            var resolver = {
                resolve: $routeProvider.ResolverFactory.moduleIsActivated("tripadvisor").resolver
            };

            $routeProvider
                .when('/tripadvisor/', {
                    templateUrl: require('../templates/tripadvisor.html'),
                    resolve: resolver
                });
        }]);

})(upp);


// WEBPACK FOOTER //
// ./src/app/modules/tripadvisor/routes/tripadvisor-routes.js